module.exports = __webpack_public_path__ + "img/edit_extra_companies.7a28e748.svg";